import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-featured-topics-card',
    templateUrl: './featured-topics-card.component.html',
    styleUrls: ['./featured-topics-card.component.scss'],
    standalone: true,
    imports: [FlexModule, MatCardModule, NgClass, ExtendedModule, MatChipsModule, NgIf, MatButtonModule]
})
export class FeaturedTopicsCardComponent {
	@Input() featuredCardData: any;

	constructor() {}

	ngOnInit(): void {}

	redirectToDonate(link: string): void {
		// window.open(link, '_blank');
		window.location.href = link;
	}
}
